<template>
    <div v-on:click="backPagePrevious" class="c-btn-check l-shop-deal__box-back box-center" style="bottom: 130px;">
        <div class="l-shop-deal__box-back--icon"><img src="/assets/images/icon/icon-back.svg" alt=""></div>
        <div class="l-shop-deal__box-back--title">戻る</div>
        <div class="l-shop-deal__box-back--icon"></div>
    </div>
</template>
<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'ButtonBack',
    methods: {
        backPagePrevious() {
            this.$router.back();
        },
    },
});
</script>
